import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar, MatDialog } from '@angular/material';
import { RespostaListaDinamicaService } from 'unb-questionario-componente';
import { Resposta } from 'unb-questionario-componente';
import { Inscricao } from '../inscricao/inscricao';
import { InscricaoService } from '../inscricao/inscricao.service';
import { InscricaoTrabalhoService } from './inscricao-trabalho.service';
import { InscricaoTrabalho } from './inscricao-trabalho';
import { Confirmacao } from '../util/confirmacao';
import { ConfirmacaoDialog } from '../util/confirmacao.dialog';
import { FormControl, Validators, NgControl } from '@angular/forms';
import { InscricaoTrabalhoDialogComponent } from './inscricao-trabalho-dialog.component';

@Component({
  selector: 'inscricao-trabalho-list',
  templateUrl: './inscricao-trabalho-list.component.html',
  styleUrls: [ './inscricao-trabalho-list.component.css' ]
})
export class InscricaoTrabalhoListComponent implements OnInit {
  @Input() ehAdmin : boolean;
  @Input() inscricao : Inscricao;
  @Input() botaoNovo: boolean = true;

  @Output() quantidadeTrabalhos: EventEmitter<number> = new EventEmitter<number>();

  public isLoading: boolean;
  public mensagemTela: string;
  public matriculaAluno: string;
  public lista : InscricaoTrabalho[];

  public botaoSalvar: boolean= true;

  constructor(private inscricaoTrabalhoService: InscricaoTrabalhoService,
    private inscricaoService: InscricaoService,
    private mensagem: MatSnackBar,
    public dialog: MatDialog)  {
  }

  ngOnInit() {
    if(this.inscricao && this.inscricao.id){
      this.mensagemTela = "Você pode cadastrar até um trabalho (tese/dissertação) por ano."
      this.buscar();
      this.controlaBotaoSalvar();
    }
  }

  buscar(){
    let filtro: InscricaoTrabalho = new InscricaoTrabalho;
    filtro.codigoInscricao = this.inscricao.id;
    this.inscricaoTrabalhoService.filtrar(filtro).subscribe(
      (result:InscricaoTrabalho[]) => {
        this.lista = result;
        this.controlaBotaoNovo();
        if(result){
          this.quantidadeTrabalhos.emit(result.length);
        }

      },  error =>  this.erro(error)
    );
  }

  // Emite a row rowSelecionada
  public editar(event: InscricaoTrabalho): void{
    this.carregarDialog(event);
  }

  public novo(): void{
    if(this.matriculaAluno){
      let inscricaoTrabalho: InscricaoTrabalho = new InscricaoTrabalho();
      inscricaoTrabalho.alunoRa = this.matriculaAluno.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
      inscricaoTrabalho.codigoInscricao = this.inscricao.id;
      this.carregarNovo(inscricaoTrabalho);
      // reseto a matrícula
      this.matriculaAluno = null;
    }else{
      this.mensagem.open("Digite a matrícula do aluno e clique em novo.", 'X', {duration: 5000});
    }
  }


  public carregarNovo(event: InscricaoTrabalho){
    this.isLoading = true;
    this.inscricaoTrabalhoService.inicializaInscricaoTrabalho(event.alunoRa).subscribe((result:InscricaoTrabalho) => {
      if(result){
        result.codigoInscricao = this.inscricao.id;
        this.carregarDialog(result);
        this.isLoading = false;
      }
    },error =>  this.erro(error));
  }

  private carregarDialog(inscricaoTrabalho: InscricaoTrabalho){
    let dialogRef = this.dialog.open(InscricaoTrabalhoDialogComponent, {
        width: '1024px',
        height: '768px',
        data: {inscricaoTrabalho: inscricaoTrabalho, botaoSalvar: this.botaoSalvar}
      });

      dialogRef.afterClosed().subscribe(result => {
        this.buscar();
      });
  }



  public controlaBotaoNovo(){
    if(this.lista && this.lista.length > 4){
      this.botaoNovo = false;
    }
  }

  public excluir(event: InscricaoTrabalho){
    let confirmacao: Confirmacao = new Confirmacao("Deseja excluir o registro: " + event.alunoNome, false);
    let dialogRef = this.dialog.open(ConfirmacaoDialog, {
        width: '400px',
        data: confirmacao,
      });

      dialogRef.afterClosed().subscribe(result => {
        if(result){
          this.deletar(event);
        }
      });
  }


  private deletar(inscricaoTrabalho: InscricaoTrabalho){
    this.isLoading = true;
    this.inscricaoTrabalhoService.deletar(inscricaoTrabalho).subscribe(
      result => {
        this.mensagem.open("Registro excluído com sucesso!", 'X', {duration: 5000});
        this.buscar();
      },
      error =>  this.erro(error)
    );
  }

  public controlaBotaoSalvar(){
    this.botaoSalvar = this.inscricaoService.controlaBotaoSalvar(this.inscricao, this.ehAdmin);
  }


  // mostra erros na tela
   private erro(erro: string): void{
       this.mensagem.open(erro, 'X', {duration: 5000});
       this.isLoading= false;
   }

   // finaliza o subscribe
   finaliza(): void{
     this.isLoading=false;
   }
}
